var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransaction1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54215 9.86149C11.9424 7.48171 15.6143 7.14262 18.3899 8.82504C17.4488 9.74593 16.3659 10.823 16.3659 10.823C15.604 11.7253 16.4572 12.2457 16.8915 12.2308H21.9598C22.2298 12.2308 22.4492 12.2308 22.4492 12.2308H23.9221C24.1884 12.2308 24.4067 12.0146 24.4067 11.7473V4.84223C24.4395 4.2138 23.7393 3.5998 23.0139 4.30421C23.0139 4.30421 21.818 5.45991 20.9936 6.26889C16.7673 3.21326 10.8119 3.55996 6.99339 7.33756C4.76486 9.54438 3.7296 12.4695 3.85371 15.3585H7.46022C7.33239 13.3865 8.0186 11.3712 9.54213 9.86149L9.54215 9.86149Z",
    fill: "#212121",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5399 14.1592C21.6677 16.1348 20.9815 18.1493 19.458 19.6591C17.054 22.0352 13.3858 22.3753 10.6103 20.6955C11.5514 19.7746 12.6345 18.6986 12.6345 18.6986C13.3925 17.7953 12.5392 17.2759 12.1087 17.2906H7.0366C6.77063 17.2906 6.55125 17.2906 6.55125 17.2906H5.078C4.80807 17.2906 4.58974 17.5068 4.58974 17.7704V24.6754C4.56063 25.3067 5.26087 25.9179 5.98254 25.2134C5.98254 25.2134 7.17845 24.0614 8.00652 23.2488C12.2331 26.3081 18.1883 25.9614 22.003 22.1801C24.2316 19.9772 25.2705 17.0484 25.1464 14.1592H21.5399V14.1592Z",
    fill: "#212121",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction1);
export default __webpack_public_path__ + "static/media/transaction1.8a8b2163.svg";
export { ForwardRef as ReactComponent };